import { SERIE_CREATE_GQL, SERIE_DELETE_GQL, SERIE_UPDATE_GQL } from './gql';
import { apolloClient } from '../client';
import { SerieInput } from './serie.types';
import { Serie } from '../types.generated';

export const createSerieMutation = async (payload: Omit<SerieInput, 'id'>): Promise<Serie | undefined> => {
  const response = await apolloClient.mutate<{ createSerie: Serie }>({
    mutation: SERIE_CREATE_GQL,
    variables: {
      input: payload,
    },
  });

  return response.data?.createSerie;
};

export const updateSerieMutation = async (payload: SerieInput): Promise<Serie | undefined> => {
  const { id, ...restData } = payload;

  const response = await apolloClient.mutate<{ updateSerie: Serie }>({
    mutation: SERIE_UPDATE_GQL,
    variables: {
      id,
      input: restData,
    },
  });

  return response.data?.updateSerie;
};

export const deleteSerieMutation = async (id: Serie['id']): Promise<Serie['id'] | undefined> => {
  const response = await apolloClient.mutate<{ deleteSerie: Serie['id'] }>({
    mutation: SERIE_DELETE_GQL,
    variables: {
      id,
    },
  });

  return response.data?.deleteSerie;
};
